import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import ResetPasswordForm from './ResetPasswordForm';
import ValidationError from './ValidationError';
import Spinner from '../../../../shared/_TBComponents/Spinner';
import Text from '../../../../shared/_TBComponents/Text';
import Logo from '../../../../shared/images/full-logo-black-orange.png';
import getAllUrlParams from '../../../../shared/utils/getAllUrlParams';
import useReset from '../hooks/useReset';

const FormContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: auto;
  padding: 60px 48px;
  width: 440px;
`;

const TitleArea = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;

  img {
    align-self: center;
    width: 250px;
  }
`;

const FormArea = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const ResetContainer = ({ isIdnty, isSetPassword }) => {
  const isValidating = useSelector((state) => state.forgot.ui.isValidating);
  const validateError = useSelector((state) => state.forgot.ui.validateError);

  const {
    handleResetLogOut,
    handleValidate,
    handleValidateSet,
  } = useReset();

  const url = getAllUrlParams(window.location.href, false);
  const tokenString = url.token;

  // Skip the logout for IDNTY - the point of this flow is letting an
  // already-active user (logged into another org in this browser) add
  // IDNTY without losing that session.
  useEffect(() => {
    if (!isIdnty) {
      handleResetLogOut();
    }
    if (isSetPassword) {
      handleValidateSet({ token: tokenString });
    } else {
      handleValidate({ token: tokenString });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (validateError) {
    return (
      <ValidationError
        isIdnty={isIdnty}
        isSetPassword={isSetPassword}
        validateError={validateError}
      />
    );
  }

  let title = 'Reset your password';
  if (isIdnty) {
    title = 'Set a new password to join IDNTY';
  } else if (isSetPassword) {
    title = 'Set your password';
  }

  return (
    <FormContainer>
      {isValidating ? <Spinner /> : (
        <>
          <TitleArea>
            <img alt='Teambuildr' className='img-fluid' src={Logo} />
            <Text styledTextProps={{ fontSize: '23px', fontWeight: '700' }}>{title}</Text>
          </TitleArea>
          <FormArea>
            <ResetPasswordForm
              isIdnty={isIdnty}
              isSetPassword={isSetPassword}
              tokenString={tokenString}
            />
          </FormArea>
        </>
      )}
    </FormContainer>
  );
};

ResetContainer.propTypes = {
  isIdnty: PropTypes.bool,
  isSetPassword: PropTypes.bool,
};

ResetContainer.defaultProps = {
  isIdnty: false,
  isSetPassword: false,
};

export default ResetContainer;
